export class SalesAgreementCancellation {
    public salesAgreementId: number;
    public revertToDirt: boolean;
}